import type { LegalSection } from '../legalDocuments.constants'
import { WC2026_ORG_BILLING_TERMS_SECTION } from '../../../shared/constants/wc2026OrgBillingDisclosure.constants'

const PT_PRIVACY_POLICY_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Introdução',
    paragraphs: [
      'A Zporti («nós» ou «nosso») opera a aplicação móvel e web Zporti (o «Serviço»). Esta Política de Privacidade descreve como recolhemos, utilizamos e partilhamos informações quando utiliza o Serviço.',
      'Ao utilizar o Serviço, concorda com esta política. Se não concordar, por favor não utilize o Serviço.',
    ],
  },
  {
    title: 'Informações que recolhemos',
    paragraphs: [
      'Informações de conta e perfil: como nome, endereço de e-mail, nome de utilizador, seleção de avatar ou imagem de perfil, e dados semelhantes que forneça ao criar ou atualizar a sua conta.',
      'Dados de autenticação: utilizamos autenticação Supabase e podemos suportar início de sessão por e-mail, fornecedores OAuth (por exemplo, Google ou Facebook) e sessões de convidado consoante a plataforma e a versão.',
      'Conteúdo que cria: como previsões desportivas, desafios, membros de grupos, ligações de amizade, convites e mensagens que envia através de formulários de contacto ou suporte.',
      'Informações de utilização e do dispositivo: como eventos da aplicação, localização aproximada derivada do endereço IP quando aplicável, tipo de dispositivo, sistema operativo e dados de diagnóstico para manter o Serviço seguro e fiável.',
    ],
  },
  {
    title: 'Cookies, analítica e consentimento',
    paragraphs: [
      'Na web, utilizamos cookies ou armazenamento essencial para autenticação, segurança e funcionamento básico da aplicação.',
      'A analítica não essencial está desativada por predefinição até que dê o seu consentimento. Pode alterar esta preferência mais tarde nos controlos de privacidade na aplicação.',
      'Se ativada, os fornecedores de analítica podem processar eventos de utilização pseudonimizados e metadados limitados da conta para nos ajudar a melhorar a qualidade e fiabilidade do produto.',
    ],
  },
  {
    title: 'Comunicações de marketing',
    paragraphs: [
      'Os e-mails de marketing são opt-in. Só enviamos comunicações de marketing quando consente ativamente.',
      'Pode retirar o consentimento de marketing a qualquer momento nos controlos de privacidade.',
      'Quando cria uma conta, registamos a data e a versão da política para o consentimento opcional de marketing e para a sua aceitação dos nossos Termos de Serviço e Política de Privacidade, para podermos demonstrar o que aceitou, se necessário.',
    ],
  },
  {
    title: 'Como utilizamos as informações',
    paragraphs: [
      'Utilizamos as informações acima para fornecer e melhorar o Serviço, autenticar utilizadores, personalizar a sua experiência, operar desafios e classificações, enviar avisos relacionados com o serviço, analisar a utilização de forma agregada, prevenir fraude e abusos, e cumprir a lei.',
    ],
  },
  {
    title: 'Como partilhamos as informações',
    paragraphs: [
      'Partilhamos informações com prestadores de serviços que nos ajudam a alojar o Serviço, enviar e-mail, processar analítica ou realizar funções semelhantes, sujeito a salvaguardas adequadas.',
      'Podemos divulgar informações se a lei o exigir, para proteger os nossos direitos e os dos utilizadores, ou no âmbito de uma fusão ou venda de ativos (com aviso quando necessário).',
      'Outros utilizadores podem ver informações que escolhe tornar visíveis na aplicação (por exemplo, nome de exibição, avatar e atividade relacionada com desafios) de acordo com as funcionalidades do produto.',
    ],
  },
  {
    title: 'Conservação',
    paragraphs: [
      'Conservamos informações enquanto a sua conta estiver ativa e pelo tempo necessário para prestar o Serviço, cumprir obrigações legais, resolver disputas e fazer cumprir os nossos acordos.',
    ],
  },
  {
    title: 'As suas escolhas e direitos',
    paragraphs: [
      'Consoante o local onde vive, pode ter direito a aceder, corrigir, eliminar ou exportar as suas informações pessoais, ou a opor-se ou restringir certos tratamentos.',
      'Os controlos de privacidade na aplicação incluem pedidos de eliminação de conta, controlos de consentimento de marketing e transferência de exportação de dados quando disponível.',
      'Também pode contactar-nos em info@zporti.com. Poderemos precisar de verificar o seu pedido antes de responder.',
    ],
  },
  {
    title: 'Crianças',
    paragraphs: [
      'O Serviço não se destina a crianças com menos de 13 anos (ou a idade mínima exigida na sua região). Não recolhemos intencionalmente informações pessoais de crianças.',
    ],
  },
  {
    title: 'Alterações',
    paragraphs: [
      'Podemos atualizar esta Política de Privacidade periodicamente. Publicaremos a versão atualizada nesta página e atualizaremos a data de vigência quando o fizer.',
    ],
  },
  {
    title: 'Contacto',
    paragraphs: [
      'Questões sobre esta política: info@zporti.com',
    ],
  },
]

const PT_DATA_DELETION_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Visão geral',
    paragraphs: [
      'Pode solicitar a eliminação de dados pessoais associados à sua conta Zporti. Esta página descreve como fazer esse pedido e o que pode esperar.',
    ],
  },
  {
    title: 'Como solicitar a eliminação',
    paragraphs: [
      'Utilize os controlos de privacidade na aplicação para solicitar a eliminação da conta a partir da sua sessão autenticada.',
      'Ou envie um e-mail para info@zporti.com a partir do endereço de e-mail associado à sua conta Zporti (ou identifique claramente o e-mail da conta e quaisquer outros dados que possamos usar para localizar o seu perfil).',
      'Utilize o assunto «Data deletion request». Poderemos pedir-lhe que confirme a sua identidade antes de processar o pedido.',
      'Também pode transferir uma cópia dos dados da sua conta nos controlos de privacidade na aplicação.',
    ],
  },
  {
    title: 'O que eliminamos',
    paragraphs: [
      'Após verificação, eliminaremos ou anonimizaremos dados pessoais ligados à sua conta quando a conservação não for necessária por motivos legais, de segurança ou de resolução de disputas.',
      'Algumas informações podem permanecer em cópias de segurança durante um período limitado até serem rotacionadas, ou quando a lei exigir conservação.',
    ],
  },
  {
    title: 'Prazos',
    paragraphs: [
      'Procuramos responder a pedidos verificados num prazo razoável e dentro de qualquer prazo exigido pela lei aplicável na sua região.',
    ],
  },
  {
    title: 'Contacto',
    paragraphs: [
      'Questões sobre eliminação de dados: info@zporti.com',
    ],
  },
]

const PT_TERMS_OF_SERVICE_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Acordo',
    paragraphs: [
      'Estes Termos de Serviço («Termos») regem o seu acesso e utilização da aplicação móvel e web Zporti (o «Serviço») operada pela Zporti («nós» ou «nosso»).',
      'Ao criar uma conta, aceder ou utilizar o Serviço, concorda com estes Termos. Se não concordar, não utilize o Serviço.',
      'Ao registar-se, confirma a aceitação destes Termos e da nossa Política de Privacidade separadamente de qualquer consentimento opcional para e-mails de marketing.',
    ],
  },
  {
    title: 'O Serviço',
    paragraphs: [
      'A Zporti oferece uma experiência social de previsões e desafios desportivos: pode criar ou juntar-se a desafios com amigos, submeter previsões, ver resultados e classificações, e utilizar funcionalidades relacionadas que possamos adicionar ou alterar ao longo do tempo.',
      'Podemos modificar, suspender ou descontinuar partes do Serviço com aviso razoável quando praticável. Não garantimos funcionamento ininterrupto ou isento de erros.',
    ],
  },
  {
    title: 'Elegibilidade e contas',
    paragraphs: [
      'Deve cumprir a idade mínima exigida na sua região para utilizar o Serviço (normalmente pelo menos 13 anos, ou superior se a lei local o exigir).',
      'É responsável pela exatidão das informações que fornece e por manter seguras as suas credenciais de acesso. Notifique-nos prontamente através do contacto abaixo se suspeitar de acesso não autorizado à sua conta.',
    ],
  },
  {
    title: 'Utilização aceitável',
    paragraphs: [
      'Concorda em não fazer uso indevido do Serviço. Por exemplo, não deve: infringir a lei; assediar, abusar ou prejudicar outros; tentar obter acesso não autorizado aos nossos sistemas ou às contas de outros utilizadores; extrair dados ou sobrecarregar o Serviço; distribuir malware; fazer batota, manipular ou perturbar desafios ou resultados; ou utilizar o Serviço para enviar spam ou comunicações enganosas.',
      'Podemos investigar e suspender ou encerrar contas que violem estes Termos ou coloquem o Serviço ou os utilizadores em risco.',
    ],
  },
  {
    title: 'Conteúdo do utilizador',
    paragraphs: [
      'Conserva os direitos sobre o conteúdo que submete (como informações de perfil, mensagens e atividade em desafios). Concede-nos uma licença não exclusiva para alojar, armazenar, exibir e processar esse conteúdo conforme necessário para operar e melhorar o Serviço.',
      'É responsável pelo conteúdo que submete e confirma que tem direito a partilhá-lo. Podemos remover conteúdo que viole estes Termos ou a lei aplicável.',
    ],
  },
  {
    title: WC2026_ORG_BILLING_TERMS_SECTION.title,
    paragraphs: [...WC2026_ORG_BILLING_TERMS_SECTION.paragraphs],
  },
  {
    title: 'Isenções de responsabilidade',
    paragraphs: [
      'O Serviço é fornecido «tal como está» e «conforme disponível» na máxima medida permitida por lei. Dados desportivos, odds e resultados podem provir de terceiros; não garantimos a sua exatidão ou atualidade.',
      'A competição amigável e as previsões são para entretenimento. Nada no Serviço constitui aconselhamento sobre apostas, financeiro ou profissional quando tal atividade é regulada ou proibida.',
    ],
  },
  {
    title: 'Limitação de responsabilidade',
    paragraphs: [
      'Na máxima medida permitida pela lei aplicável, não somos responsáveis por danos indiretos, incidentais, especiais, consequenciais ou punitivos, ou por perda de lucros, dados ou goodwill, decorrentes da sua utilização do Serviço.',
      'A nossa responsabilidade total por reclamações decorrentes do Serviço limita-se ao maior de (a) o montante que nos pagou pelo Serviço nos doze meses anteriores à reclamação ou (b) cem dólares americanos (USD $100), exceto quando a lei não permitir tal limite.',
    ],
  },
  {
    title: 'Indemnização',
    paragraphs: [
      'Concorda em defender-nos e indemnizar-nos a nós e às nossas afiliadas, dirigentes e funcionários contra reclamações, danos e despesas (incluindo honorários legais razoáveis) decorrentes da sua utilização do Serviço, do seu conteúdo ou da sua violação destes Termos, na medida permitida por lei.',
    ],
  },
  {
    title: 'Lei aplicável e disputas',
    paragraphs: [
      'Estes Termos regem-se pelas leis aplicáveis no local onde a Zporti opera o seu negócio, sem consideração de regras de conflito de leis, exceto quando proteções obrigatórias ao consumidor no seu país dispuserem o contrário.',
      'Se for consumidor, pode ter direito a intentar disputas nos tribunais do seu local de residência quando a lei o exigir.',
    ],
  },
  {
    title: 'Alterações',
    paragraphs: [
      'Podemos atualizar estes Termos periodicamente. Publicaremos os Termos atualizados nesta página. A utilização continuada do Serviço após a entrada em vigor das alterações constitui aceitação dos Termos revistos quando permitido por lei.',
    ],
  },
  {
    title: 'Contacto',
    paragraphs: [
      'Questões sobre estes Termos: info@zporti.com',
    ],
  },
]

const PT_CREDITS_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Créditos de terceiros',
    paragraphs: [
      'A Zporti utiliza recursos de áudio de terceiros selecionados para efeitos sonoros na aplicação.',
      'Os recursos de som provêm do Freesound e são utilizados sob licença CC0 (domínio público).',
    ],
  },
  {
    title: 'Atribuição de áudio',
    paragraphs: [
      'Freesound: https://freesound.org/',
      'Creative Commons CC0 1.0: https://creativecommons.org/publicdomain/zero/1.0/',
    ],
  },
]

export const PT_LEGAL_SECTIONS = {
  privacy: PT_PRIVACY_POLICY_SECTIONS,
  dataDeletion: PT_DATA_DELETION_SECTIONS,
  terms: PT_TERMS_OF_SERVICE_SECTIONS,
  credits: PT_CREDITS_SECTIONS,
} as const
